// schj
const state = {
  dataKindId: null,
  code: "zb", //当前选中的左则code,默认是流向, change to 占比
  childCode: "jyd",
  cname: "", // 当前选择的类别
  cmonth: "", // 当前选择月份
  datas: {} // save 第三方接口data
};

const mutations = {
  SET_ID: (state, v) => {
    state.dataKindId = v;
  },
  SET_CODE: (state, v) => {
    state.code = v;
  },
  SET_CHILD_CODE: (state, v) => {
    state.childCode = v;
  },
  SET_CNAME: (state, v) => {
    state.cname = v;
  },
  SET_CMONTH: (state, v) => {
    state.cmonth = v;
  },
  SET_DATAS: (state, v) => {
    state.datas = v;
  }
};

const actions = {
  setId({ commit }, v) {
    commit("SET_ID", v);
  },
  setCode({ commit }, v) {
    commit("SET_CODE", v);
  },
  setChildCode({ commit }, v) {
    commit("SET_CHILD_CODE", v);
  },
  setCname({ commit }, v) {
    commit("SET_CNAME", v);
  },
  setCmonth({ commit }, v) {
    commit("SET_CMONTH", v);
  },
  setDatas({ commit }, v) {
    commit("SET_DATAS", v);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
